export const 提示ServiceInjectToken = Symbol('提示Service');

export abstract class 提示Service {
    abstract 提示成功(内容: string): void;

    abstract 提示警告(内容: string): void;

    abstract 提示错误(内容: string): void;

    abstract 提示信息(内容: string): void;

    abstract 确认操作(内容: string, 标题?: string, 确认文本?: string, 取消文本?: string): Promise<boolean>;
}
